<template>
  <div class="richtext" data-comp="a-richtext">
    <div class="richtext__inner" v-html="html" v-if="html"></div>
    <div class="richtext__inner" else>
      <sb-richtext :text="richtext" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  richtext: {
    type: Object,
    default: () => ({}),
  },
  html: {
    type: String,
    default: "",
  },
});
</script>
<style lang="scss">
.richtext {
  h1 {
    font-family: var(--font-family-display);
    font-size: var(--font-size-h1);
    letter-spacing: -0.025em;
    line-height: var(--line-height-h1);
    font-weight: var(--font-weight-book);
    margin-bottom: 1rem;
  }
  h2 {
    font-family: var(--font-family-display);
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-weight: var(--font-weight-book);
    margin-bottom: 1rem;
  }
  h3 {
    font-family: var(--font-family-display);
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-weight: var(--font-weight-book);
    margin-bottom: 1rem;
  }
  h4 {
    font-family: var(--font-family-display);
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: var(--font-weight-book);
  }
  h5 {
    font-family: var(--font-family-display);
    font-size: calc(1rem * 1.25);
    font-weight: var(--font-weight-book);
    line-height: 1.2;
  }
  h6 {
    font-family: var(--font-family-display);
    font-size: 1rem;
    font-weight: var(--font-weight-book);
    line-height: 1.2;
  }

  p {
    margin-block-end: 3rem;
    &:first-child {
      margin-block-start: 0;
    }
    &:last-child {
      margin-block-end: 0;
    }
  }

  a {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 5%;
      height: 0.05rem;
      border-radius: 9rem;
      width: 100%;
      transform: scaleX(1);
      will-change: transform;
      background-color: currentColor;
      transform-origin: right center;
    }
    @media (hover: hover) {
      &:hover {
        &:after {
          animation: link 1s var(--ease-in-out-cubic);
        }
      }
    }
  }
}

@keyframes link {
  0% {
    transform: scaleX(1);
    transform-origin: right center;
  }
  50% {
    transform: scaleX(0);
    transform-origin: right center;
  }
  51% {
    transform: scaleX(0);
    transform-origin: left center;
  }
  100% {
    transform: scaleX(1);
    transform-origin: left center;
  }
}
</style>
